var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Notifications"},[_c('h1',[_vm._v("Cards Pending Your Approval")]),_vm._v(" "),_vm._l((_vm.cards),function(card){return _c('card',{key:card.objectID,attrs:{"pendingApproval":true,"data":card,"full":false}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eab8c20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications.vue
// module id = nvIt
// module chunks = 1 2 3